/**
 * @generated SignedSource<<d584e1b8f1dbe67e3b1d4db631a9101b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowInner_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow_rules" | "useRowColor_savedView_rules">;
  readonly " $fragmentType": "RowInner_rules";
};
export type RowInner_rules$key = {
  readonly " $data"?: RowInner_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "RowInner_rules",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewconditionalformattingenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useRowColor_savedView_rules"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueRow_rules"
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "9ebb21229d16cd8d8f5a9e2d4f85a37e";

export default node;
